<div class="flex flex-col w-full space-y-2">
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>
      Search for Location
    </mat-label>
    <input matInput type="text" (keydown.enter)="$event.preventDefault()"
      placeholder="Search Nearest Location" autocorrect="off"
      autocapitalize="off" spellcheck="off" type="text"
      #search/>
  </mat-form-field>

  <!-- agm-map removed: AGM (Angular Google Maps) is not currently configured -->
  <!-- Map will be displayed here when AGM integration is restored -->

  @if (showAddress) {
    <div>
      <h5>Address: {{address}}</h5>
      <div>Latitude: {{latitude}}</div>
      <div>Longitude: {{longitude}}</div>
    </div>
  }
</div>
